import { 
  DataTableColumnModel,
  DataTableInlineEditingConfigEnum,
  DataTableInlineEditingConfigModel,
  DataTableItemsPerPageEnum,
  DataTableSortEnum,
  DataTableStateModel
} from "app/shared/components/dynamic-table/dynamic-table.model";

const inlineInputField: DataTableInlineEditingConfigModel = {
  field: DataTableInlineEditingConfigEnum.INPUT_FIELD,
  placeholder: 'placeholders.type_text_here',
  cellPlaceholder: 'placeholders.type_text_here'
};

const inlineSelectField: DataTableInlineEditingConfigModel = {
  field: DataTableInlineEditingConfigEnum.SELECT_FIELD,
  placeholder: 'placeholders.please_select',
  cellPlaceholder: 'placeholders.please_select',
  selectConfig: {
    items: [],
    isRelatedField: true,
    bindLabel: 'value',
    bindValue: 'value',
    searchable: true,
    clearable: true,
    addTag: true,
  }
};

const userInlineSelectField: DataTableInlineEditingConfigModel = {
  field: DataTableInlineEditingConfigEnum.SELECT_FIELD,
  placeholder: 'placeholders.please_select',
  cellPlaceholder: 'placeholders.please_select',
  selectConfig: {
    items: [],
    isRelatedField: true,
    bindLabel: 'fullName',
    bindValue: 'fullName',
    searchable: true,
    clearable: true,
    addTag: false,
    addSelectedItem: true
  }
};

const actionButtons = {
  save: true,
  delete: true,
  discardChanges: true
}

const CASE_TYPE_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.case_type", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const CLASSIFICATION_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.classifications", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const EQUIPMENT_STATUS_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.equipment_status", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const FAMILY_NAME_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.family_name", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const FAMILY_VARIANT_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.family_variant", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const PROCESS_TYPE_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.process_type", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const STC_ENGAGED_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.stc_region_location",
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const SUPPLIER_ENGAGED_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.supplier_engaged", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const ESCALATION_CATEGORY_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.escalation_category", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const ROOT_CAUSE_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.rootCauseCodeText", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const DISTRIBUTED_MANUFACTURING_PC_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "case.fields.distributedManufacturingPc.label", 
    prop: "entry1", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const CUSTOMER_INFORMATION_COMPONENT_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.customer_region",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.customer_country",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.customer_name_site",
    prop: "entry3", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry3_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 220,
  },
  { 
    name: "label.sma_factory_name",
    prop: "entry4", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry4_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.global_customer_name",
    prop: "entry5", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry5_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 250,
  },
  { 
    name: "label.customer_city",
    prop: "entry6", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry6_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const PROCESS_INFORMATION_COMPONENT_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.tool_manufacturer",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.tool",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  {
    name: "label.chamber",
    prop: "entry3", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry3_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.product_company",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  { 
    name: "label.product_suite",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  {
    name: "label.system_component",
    prop: "entry3", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry3_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  {
    name: "label.category",
    prop: "entry4", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry4_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const PRODUCT_INFORMATION_COMPONENT_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.product_family",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.product_group",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  {
    name: "label.product_sub_group",
    prop: "entry3", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry3_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  {
    name: "label.product_company",
    prop: "entry4", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry4_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 200,
  },
  {
    name: "label.product_suite",
    prop: "entry5", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry5_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const STC_COMPLEX_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.stc_name",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.failure_analysis_manager",
    prop: "user1", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 250,
  },
  { 
    name: "label.quality_manager",
    prop: "user2", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 230,
  },
  { 
    name: "label.comments", 
    prop: "comments", 
    inlineEditingConfig: inlineInputField,
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const CUSTOMER_CENTER_COMPLEX_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.customer_region",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.product_suite",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.tech_support_manager",
    prop: "user1", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 220,
  },
  { 
    name: "label.tech_support_manager_backup",
    prop: "user2", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 280,
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const CUSTOMER_CENTER_APPS_COMPLEX_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.customer_region",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.apps_manager",
    prop: "user1", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.apps_manager_backup",
    prop: "user2", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const PRODUCT_COMPANY_COMPLEX_TABLE_CONFIG: DataTableColumnModel[] = [
  { 
    name: "label.customer_region",
    prop: "entry1", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.product_company",
    prop: "entry2", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.product_suite",
    prop: "entry3", 
    inlineEditingConfig: inlineSelectField,
    selectFieldKey: 'entry3_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true
  },
  { 
    name: "label.pc_support_manager",
    prop: "user1", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user1_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 220,
  },
  { 
    name: "label.pc_support_manager_backup",
    prop: "user2", 
    inlineEditingConfig: userInlineSelectField,
    selectFieldKey: 'user2_items',
    hasFilter: true,
    sortable: true,
    showFilterSearch: true,
    minWidth: 280,
  },
  { 
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 125,
    actionButtons: actionButtons
  },
];

const CONFIGURE_INFORMATION_TABLE_STATE: DataTableStateModel = {
  sortingValue: {
    prop: '',
    dir: DataTableSortEnum.SORT_DESC
  },
  pageNumber: 1,
  showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10,
  gridName: '',
  tableType: ''
};

export {
  CASE_TYPE_TABLE_CONFIG,
  CLASSIFICATION_TABLE_CONFIG,
  EQUIPMENT_STATUS_TABLE_CONFIG,
  FAMILY_NAME_TABLE_CONFIG,
  FAMILY_VARIANT_TABLE_CONFIG,
  PROCESS_TYPE_TABLE_CONFIG,
  SUPPLIER_ENGAGED_TABLE_CONFIG,
  STC_ENGAGED_TABLE_CONFIG,
  ESCALATION_CATEGORY_TABLE_CONFIG,
  ROOT_CAUSE_TABLE_CONFIG,
  DISTRIBUTED_MANUFACTURING_PC_TABLE_CONFIG,
  CUSTOMER_INFORMATION_COMPONENT_TABLE_CONFIG,
  PROCESS_INFORMATION_COMPONENT_TABLE_CONFIG,
  PRODUCT_INFORMATION_COMPONENT_TABLE_CONFIG,
  ROOT_CAUSE_SYSTEM_COMPONENT_COMPLEX_TABLE_CONFIG,
  CONFIGURE_INFORMATION_TABLE_STATE,
  STC_COMPLEX_TABLE_CONFIG,
  CUSTOMER_CENTER_APPS_COMPLEX_TABLE_CONFIG,
  CUSTOMER_CENTER_COMPLEX_TABLE_CONFIG,
  PRODUCT_COMPANY_COMPLEX_TABLE_CONFIG
}
